module.exports = __webpack_public_path__ + "img/texto_light.6fedab66.png";